import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Layout } from "antd";
import { InputItem } from "../../components/forms/FormItems";
import ImageFormItem from "../../components/forms/ImageFormItem";
import FloatingFormActions from "../../components/forms/FloatingFormActions";
import { useIntl } from "react-intl";
import AutoCompleteItem from "../../components/forms/AutoCompleteItem";
import Surface from "../../components/layouts/Surface";
import Centered from "../../components/layouts/Centered";
import Spacer from "../../components/layouts/Spacer";
import { useSelector, useDispatch } from "react-redux";
import { setChangedFormItems, commitChanges } from "./UserSlice";
import { FormattedMessage } from "react-intl";
import { Typography } from "antd";
import FormHeader from "../../components/forms/FormHeader";
import ContentSider from "../../components/templates/ContentSider";
import ResponsiveItemsWrapper from "../../components/layouts/ResponsiveItemsWrapper";
import { getChangedItems } from "../../components/util/helpers";
import EnrollTotp from "./components/EnrollTotp";
const { Content } = Layout;

const { Title, Text } = Typography;
var flatten = require("flat");

const Profile = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [form] = Form.useForm();
  const profile = useSelector((state) => state.user.profile);
  const saveLoading = useSelector(
    (state) => state.pendingActions["user/update"]
  );
  const changedItems = useSelector((state) => state.user.changedItems.changed);

  useEffect(() => {
    const flat = flatten(profile);
    form.setFieldsValue(flat);
  }, [profile, form]);

  const onDecline = () => {
    const flat = flatten(profile);
    form.setFieldsValue(flat);
  };

  const onValuesChange = (changedValues, allValues) => {
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      profile
    );
    dispatch(setChangedFormItems({ changed: arr, values: allValues }));
  };

  return (
    <Form
      layout={"vertical"}
      style={{ width: "fitContent" }}
      onFinish={() => dispatch(commitChanges())}
      form={form}
      onValuesChange={onValuesChange}
    >
      <Layout style={{ background: "transparent", height: "100%" }}>
        <Spacer horizontal={true} smallMargin={true} />
        <ContentSider width={250}>
          <Centered
            style={{
              justifyContent: "start",
              flexDirection: "column",
              padding: "40px",
              borderRadius: "5px",
            }}
          >
            <ImageFormItem name="avatar_url" />
            <Title level={3}>{profile.name}</Title>
            <Text>{profile.user_name}</Text>
            <Text type="secondary" style={{ direction: "ltr" }}>
              {profile.phone_number}
            </Text>
          </Centered>
        </ContentSider>
        <Content style={{ minHeight: 280 }}>
          <Surface>
            <FormHeader
              title={<FormattedMessage id="app.forms.editUserTitle" />}
            />
            <Row>
              <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="name" required={true} category="user" />
                  </div>

                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <AutoCompleteItem
                      name="address.city"
                      category="user"
                      city={true}
                    />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="address.street" category="user" />
                  </div>

                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem name="address.house_number" category="user" />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem
                      name="address.postal_code"
                      postalCode={true}
                      category="user"
                    />
                  </div>

                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem
                      name="address.apartment_number"
                      category="user"
                    />
                  </div>
                </ResponsiveItemsWrapper>
              </Col>
            </Row>
            <EnrollTotp />
          </Surface>
          <FloatingFormActions
            resource={"profile"}
            action={"editor"}
            onCancel={onDecline}
            mode={"edit"}
            formName={profile.user_name}
            onDecline={onDecline}
            hideDelete={true}
            hideDecline={true}
            saveLoading={saveLoading}
            saveText={intl.formatMessage({
              id: "app.actions.saveChanges",
            })}
            show={changedItems.length > 0}
          />
        </Content>
      </Layout>
    </Form>
  );
};

Profile.propTypes = {
  mode: PropTypes.string,
};

export default Profile;

// <ImageUploader
//   addImage={addImage}
//   uri={profile.avatar_url}
//   avatarUrl={avatarUrl}
// />
